
import { DiaryEntry, SupabaseEntry } from './types';

/**
 * Transforms a DiaryEntry object to match Supabase table schema
 */
export function entryToSupabaseFormat(entry: DiaryEntry): SupabaseEntry {
  return {
    id: entry.id,
    user_id: entry.userId,
    entry_text: entry.entryText,
    baby_name: entry.babyName,
    baby_age: entry.age,
    mood: entry.mood,
    milestone: entry.milestone || entry.milestones?.[0],
    created_at: entry.createdAt,
    date: entry.date || null, // Handle null case explicitly
    is_premium: entry.isPremium,
    title: entry.title || `Today with ${entry.babyName}`,
    height: entry.height,
    weight: entry.weight,
    diaper_changes: entry.diaperChanges,
    milk_intake: entry.milkIntake,
    activities: entry.activities ? JSON.stringify(entry.activities) : null,
    milestones: entry.milestones ? JSON.stringify(entry.milestones) : null,
    images: entry.images ? JSON.stringify(entry.images) : null,
  };
}

/**
 * Transforms a Supabase database row to a DiaryEntry object
 */
export function supabaseToEntryFormat(data: any): DiaryEntry {
  const activities = data.activities ? 
    (typeof data.activities === 'string' ? JSON.parse(data.activities) : data.activities) : 
    [];
    
  const milestones = data.milestones ? 
    (typeof data.milestones === 'string' ? JSON.parse(data.milestones) : data.milestones) : 
    (data.milestone ? [data.milestone] : []);
    
  const images = data.images ? 
    (typeof data.images === 'string' ? JSON.parse(data.images) : data.images) : 
    [];

  return {
    id: data.id,
    userId: data.user_id,
    entryText: data.entry_text,
    babyName: data.baby_name,
    age: data.baby_age,
    mood: data.mood,
    milestone: data.milestone,
    milestones: milestones,
    activities: activities,
    createdAt: data.created_at,
    date: data.date,
    isPremium: data.is_premium,
    title: data.title,
    height: data.height,
    weight: data.weight,
    diaperChanges: data.diaper_changes,
    milkIntake: data.milk_intake,
    images: images
  };
}
